import { render, staticRenderFns } from "./OrderTotalsInfo.vue?vue&type=template&id=7c54b288&"
import script from "./OrderTotalsInfo.vue?vue&type=script&lang=js&"
export * from "./OrderTotalsInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotalsInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports